import React, { memo } from "react";
import { WitLabel } from "../../shared/widgets/common";
import { FormattedMessage } from "react-intl";
import { messages } from "../messages";
import { StyledInfoIcon, StyledReactTooltip } from "../styles";
import { FieldProps } from "react-jsonschema-form";
import { FormControl, FormLabel, FormGroup } from "react-bootstrap";

const Tooltip = memo(() => {
  return (
    <>
      <StyledInfoIcon className="fa fa-info-circle" data-tip="React-tooltip" />
      <StyledReactTooltip place="right" type="dark" effect="solid">
        <FormattedMessage {...messages.accommodationBaseAdultsInfo} />
      </StyledReactTooltip>
    </>
  );
});

export default function AccommodationBaseAdultsWidget({ formData, onChange }: FieldProps) {
  return (
    <>
      <WitLabel>
        <FormattedMessage {...messages.accommodationOccupancyConfiguration} />
      </WitLabel>
      <FormGroup>
        <FormLabel>
          <FormattedMessage {...messages.accommodationBaseAdults} />*
          <Tooltip />
        </FormLabel>
        <FormControl
          type="number"
          onChange={event => onChange(Number(event.target.value))}
          value={formData}
          min={0}
        />
      </FormGroup>
    </>
  );
}
